<template>
  <div class="search" @touchend="toPage('/search')" v-if="$route.meta.searchFlag">
    <img src="/static/img/search.png" alt>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toPage(url) {
      console.log(this.$route.fullPath)
      this.$router.push({
        path:url,
        query:{
          nowUrl:this.$route.fullPath
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../common/minix.less";
.search {
  width: 50 / @rem;
  height: 50 / @rem;
  background: #eef1f4;
  border-radius: 10 / @rem;
  overflow: hidden;
  img {
    display: block;
    width: 34 / @rem;
    height: 33 / @rem;
    margin: 8 / @rem auto;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/common/search.vue